import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

export default function ImageUploader({ onImageUpload }) {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');

  const onDrop = useCallback((acceptedFiles) => {
    setError('');
    
    if (acceptedFiles.length === 0) {
      return;
    }
    
    const file = acceptedFiles[0];
    
    // Überprüfen, ob es sich um ein Bild handelt
    if (!file.type.match('image.*')) {
      setError('Bitte lade nur Bilder hoch.');
      return;
    }
    
    // Vorschaubild erstellen
    const reader = new FileReader();
    reader.onload = () => {
      setPreview(reader.result);
      if (onImageUpload) {
        onImageUpload(file);
      }
    };
    reader.readAsDataURL(file);
  }, [onImageUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.webp']
    },
    maxFiles: 1
  });

  return (
    <div className="space-y-4">
      <div 
        {...getRootProps()} 
        className={`border-2 border-dashed rounded-lg p-8 cursor-pointer text-center transition duration-300 ease-in-out ${
          isDragActive 
            ? 'border-primary-500 bg-primary-50' 
            : 'border-gray-300 hover:border-primary-400 hover:bg-gray-50'
        }`}
      >
        <input {...getInputProps()} />
        <div className="space-y-2">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p className="text-sm text-gray-600">
            Ziehe ein Bild hierher oder <span className="text-primary-600 font-medium">klicke zum Auswählen</span>
          </p>
          <p className="text-xs text-gray-500">(Nur Bilder mit geschminkten Gesichtern)</p>
        </div>
      </div>
      
      {error && (
        <div className="text-red-500 text-sm">{error}</div>
      )}
      
      {preview && (
        <div className="rounded-lg overflow-hidden">
          <img src={preview} alt="Vorschau" className="w-full h-auto" />
        </div>
      )}
    </div>
  );
}